import moment from 'moment';
export default{
  data() {
    return {
      dataTransfer:undefined
    }
  },
  computed: {
    getDateTransfer() {
      return moment().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]')
    }
  },
  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  },
  mounted(){
      $('[data-toggle="tooltip"]').tooltip();

      this.dataTransfer = this.$route.params.dataTransfer;

    }
}



// WEBPACK FOOTER //
// ./src/pages/account/shipper/transfer-shipper-voucher-detail.js